webpackJsonp([227956834199198],{

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(6);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _underscore = __webpack_require__(22);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _articlePreviewModule = __webpack_require__(17);
	
	var _articlePreviewModule2 = _interopRequireDefault(_articlePreviewModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var event = _ref.event;
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: '/event/' + event.slug },
	    _react2.default.createElement(
	      'div',
	      { className: _articlePreviewModule2.default.cardItem },
	      _react2.default.createElement(_gatsbyImage2.default, { alt: event.title, sizes: event.thumbnail.sizes, className: _articlePreviewModule2.default.cardImage }),
	      _react2.default.createElement(
	        'div',
	        { className: _articlePreviewModule2.default.cardInfo },
	        _react2.default.createElement(
	          'h3',
	          { className: _articlePreviewModule2.default.cardTitle },
	          event.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _articlePreviewModule2.default.eventDate },
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Tanggal:'
	          ),
	          ' ',
	          event.date
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _articlePreviewModule2.default.eventLocation },
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Tempat:'
	          ),
	          ' ',
	          event.venue
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _articlePreviewModule2.default.cardExcerpt },
	          event.excerpt
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(8);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _blogModule = __webpack_require__(28);
	
	var _blogModule2 = _interopRequireDefault(_blogModule);
	
	var _pageModule = __webpack_require__(287);
	
	var _pageModule2 = _interopRequireDefault(_pageModule);
	
	var _eventPreview = __webpack_require__(231);
	
	var _eventPreview2 = _interopRequireDefault(_eventPreview);
	
	var _moment = __webpack_require__(13);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventIndex = function (_React$Component) {
	  _inherits(EventIndex, _React$Component);
	
	  function EventIndex() {
	    _classCallCheck(this, EventIndex);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  EventIndex.prototype.render = function render() {
	    var siteTitle = (0, _get2.default)(this, 'props.data.site.siteMetadata.title');
	    var posts = (0, _get2.default)(this, 'props.data.allContentfulEvent.edges');
	
	    var siteData = (0, _get2.default)(this.props, 'data.site.siteMetadata');
	    var siteDescription = 'Yuk ikutin event-event asik yang diadakan oleh YOUCAT Indonesia ini';
	
	    var moment = __webpack_require__(13);
	
	    return _react2.default.createElement(
	      'div',
	      { style: { background: '#fff' }, className: 'page-content' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        { title: 'Event | ' + siteData.title },
	        _react2.default.createElement('link', { rel: 'canonical', href: siteData.siteUrl + '/event' }),
	        _react2.default.createElement('meta', { name: 'description', content: '' + siteDescription }),
	        _react2.default.createElement('meta', { name: 'title', content: 'Event | ' + siteData.title }),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Event | ' + siteData.title }),
	        _react2.default.createElement('meta', { property: 'og:site_name', content: 'YOUCAT Indonesia' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: siteData.siteUrl + '/event' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: '' + siteDescription }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://static.youcat.id/ogimg/ogimg-youcat.png' }),
	        _react2.default.createElement('meta', { property: 'og:locale', content: 'id_ID' }),
	        _react2.default.createElement('meta', { property: 'og:type', content: 'website' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'page-title' },
	          'Event-event'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-body' },
	          _react2.default.createElement(
	            'p',
	            { className: _pageModule2.default.quote },
	            _react2.default.createElement(
	              'span',
	              { className: _pageModule2.default.quoteSign },
	              '\u201C'
	            ),
	            'Jika kamu ingin melakukan sesuatu untuk orang muda, lakukanlah bersama orang muda!',
	            _react2.default.createElement(
	              'span',
	              { className: _pageModule2.default.quoteSign },
	              '\u201D'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Nasihat dari Kardinal Christoph Schonborn, Uskup Agung Wina yang juga salah satu inspirator dan pendukung YOUCAT sejak awal mula, selalu menjadi pegangan YOUCAT Indonesia untuk tak pernah lelah hadir dan menyapa setiap orang muda, termasuk untuk menunjukkan kepadamu kalau memang #Beriman itu #BukanRecehan.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Yuk ikutan bergabung dengan event-event kami ini:'
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'event-list grid-x grid-padding-x grid-padding-y small-up-1 medium-up-2 large-up-3' },
	          posts.map(function (_ref) {
	            var node = _ref.node;
	
	            return _react2.default.createElement(
	              'li',
	              { key: node.slug, className: 'cell event-list-item' },
	              _react2.default.createElement(_eventPreview2.default, { event: node })
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return EventIndex;
	}(_react2.default.Component);
	
	exports.default = EventIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"quote":"src-pages----page-module---quote---2V7vH","quoteSign":"src-pages----page-module---quoteSign---LVBeu"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-event-js-8695b6bd076930521b52.js